import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setProcedureDirty, setUnsavedProcedureData } from 'features/procedures/proceduresSlice';

const DirtyProcedure = ({ nodeId, isNewNode = false }) => {
    const { dirty, values } = useFormikContext();
    const dispatch = useDispatch();

    useEffect(() => {
        // When entering create mode the parent dispatches setProcedureDirty(true) immediately.
        // Formik starts with dirty=false (no user changes yet), so without this guard
        // DirtyProcedure would overwrite the forced true back to false on first mount.
        // Once the user makes a change, dirty becomes true and this guard is bypassed.
        if (isNewNode && !dirty) return;
        dispatch(setProcedureDirty(dirty));
    }, [dirty, isNewNode]);

    useEffect(() => {
        // Skip for new nodes with a pending insertion position — handled by handleSubmit.
        if (values?.afterOrderIdx) {
            return;
        }

        if (nodeId !== undefined && values?.id !== undefined && String(values.id) !== String(nodeId)) {
            return;
        }

        dispatch(setUnsavedProcedureData(values));
    }, [values]);
};

export default DirtyProcedure;
